// import axios from "axios";

// const api = axios.create({
//   //baseURL: "http://your-java-server/api",
//   //withCredentials: true,   // important for Java session cookie (JSESSIONID)
//   headers: {
//     "X-Requested-With": "XMLHttpRequest"
//   },
// });

// // If Java session expired → backend returns 401
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.log("interceptors")
//     const { config, response } = error;

//     // Check if it's a 401 error and not from the initial session check.
//     // The verifySession call in App.js is expected to fail with a 401 if not logged in,
//     // and we don't want to trigger a reload loop from that.
//     if (response && response.status === 401 && !config.url.endsWith('webapi/statuspolling')) {
//       // For any other 401, force a reload to the login page.
//       window.location.href = '/#/login';
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;

import axios from "axios";

let onSessionExpired = null;

export const setSessionExpiredHandler = (handler) => {
  onSessionExpired = handler;
};

const api = axios.create({
  //baseURL: "/",
  withCredentials: true,
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (onSessionExpired) onSessionExpired();   // notify App, no redirect here
    }
    return Promise.reject(error);
  }
);

export default api;
